import axios from 'axios';
import { API_URL } from '../config';

export const createLocationCompany = async (token: string, data: any) => {
    const response = await axios.post(`${API_URL}/presenze/company/locations/`, data, {
        headers: {
            'Authorization': `${token}`,
        },
    });
    return response.data;
};

export const deleteLocationCompany = async (token: string, id: string) => {
    const response = await axios.delete(`${API_URL}/presenze/company/locations/${id}/`, {
        headers: {
            'Authorization': `${token}`,
        },
    });
    return response.data;
};

export const updateLocationCompany = async (token: string, id: string, data: any) => {
    const response = await axios.put(`${API_URL}/presenze/company/locations/${id}/`, data, {
        headers: {
            'Authorization': `${token}`,
        },
    });
    return response.data;
};
